/**
 * Omite propriedades específicas de um objeto
 * @param obj O objeto original
 * @param keys As chaves a serem omitidas
 * @returns Um novo objeto sem as propriedades especificadas
 */
export function omit<T extends Record<string, unknown>, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
  const result = { ...obj };
  keys.forEach((key) => {
    delete result[key];
  });
  return result;
}

/**
 * Omite a propriedade className de um objeto
 * @param obj O objeto original
 * @returns Um novo objeto sem a propriedade className
 */
export function omitClassName<T extends Record<string, unknown> & { className?: string }>(obj: T): Omit<T, "className"> {
  const { className: _, ...rest } = obj;
  return rest as Omit<T, "className">;
}

/**
 * Omite a propriedade className de props de componente React
 * @param props As props do componente
 * @returns Um novo objeto sem a propriedade className
 */
export function omitClassNameFromProps<T extends { className?: string }>(props: T): Omit<T, "className"> {
  const { className: _, ...rest } = props;
  return rest;
}
